<template>
  <Teleport to="body">
    <div class="exchange-mask" @click.self="handleClose">
      <div class="exchange-modal">
        <div class="exchange-inner">
          <!-- 头部 -->
          <header class="exchange-header">
            <h2 class="exchange-title">兑换记录</h2>
            <button class="back-button" type="button" @click="handleClose">
              <img style="width: 14px;height: 14px;" :src="backIcon">
              <span>返回</span>
            </button>
          </header>

          <div class="exchange-divider"></div>

          <!-- 当前次数 -->
          <section class="summary-row">
            <span class="summary-label">当前次数</span>
            <div class="summary-value">
              <span class="coin-icon">
                <img :src="COIN_ICON" alt="" />
              </span>
              <span class="summary-times">
                {{ displayTimes }}
              </span>
            </div>
          </section>

          <!-- 兑换码输入 -->
          <section class="code-section">
            <div class="section-header">
              <span class="section-title">兑换码</span>
              <span class="section-sub">
                输入兑换码后可兑换一定生成次数
              </span>
            </div>
            <div class="code-input-wrapper">
              <input
                v-model.trim="codeInput"
                class="code-input"
                type="text"
                placeholder="请输入兑换码后回车即可兑换"
                :disabled="redeemLoading"
                @keyup.enter="handleRedeem"
              />
            </div>
            <p v-if="codeError" class="code-error">
              {{ codeError }}
            </p>
          </section>

          <div class="exchange-divider"></div>

          <!-- 兑换记录列表 -->
          <section class="records-section">
            <div class="section-header">
              <span class="section-title">兑换记录</span>
              <span class="section-sub">历史兑换码记录</span>
            </div>

            <ul v-if="displayRecords.length" class="record-list">
              <li
                v-for="(item, index) in displayRecords"
                :key="index"
                class="record-item"
              >
                <div class="record-main">
                  <span class="record-code">{{ item.code }}</span>
                  <span class="record-times">
                    生成次数：{{ item.times }}次
                  </span>
                </div>
                <span class="record-time">
                  {{ item.time }}
                </span>
              </li>
            </ul>
            <div v-else class="record-empty">
              暂无兑换记录
            </div>
          </section>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, ref } from 'vue';
import COIN_ICON from '@/assets/user_time.svg';
import backIcon from '@/assets/back_icon.png';
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  totalTimes: {
    type: [Number, String],
    default: null
  },
  currentTimes: {
    type: [Number, String],
    default: 0
  },
  records: {
    type: Array,
    default: () => []
  },
  redeemLoading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'redeem']);

const codeInput = ref('');
const codeError = ref('');

const displayTimes = computed(() => {
  const value = Number(props.currentTimes);
  if (Number.isFinite(value) && value >= 0) {
    return `${value}次`;
  }
  return `${props.currentTimes || 0}次`;
});


const displayRecords = computed(() => {
  if (props.records && props.records.length) {
    return props.records;
  }
  // 无记录时不再展示示例数据，只在下方显示“暂无兑换记录”
  return [];
});

const handleClose = () => {
  if (props.redeemLoading) return;
  emit('close');
};

const handleRedeem = () => {
  if (!codeInput.value) {
    codeError.value = '请输入兑换码';
    return;
  }
  codeError.value = '';
  const value = codeInput.value;
  emit('redeem', value);
  codeInput.value = '';
};
</script>

<style scoped>
.exchange-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.exchange-modal {
  position: relative;
  width: 820px;
  max-width: calc(100% - 48px);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  color: #ffffff;
  overflow: visible;
  background:
    radial-gradient(150% 150% at 0% 0%, rgba(250, 216, 124, 0.2) 0%, rgba(250, 216, 124, 0) 60%),
    #1b1813;
  border: 1px solid #fad87c;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10.8px);
}

.exchange-inner {
  border-radius: 16px;
  background: rgba(27, 24, 19, 0.7);
  border: 0.95px solid rgba(255, 255, 255, 0.18);
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.exchange-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange-title {
  margin: 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: -0.36px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #151515;
  background: rgba(71, 71, 71, 0.4);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.back-button:hover {
  background: rgba(71, 71, 71, 0.6);
}

.back-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.exchange-divider {
  height: 1px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.16),
    rgba(255, 255, 255, 0)
  );
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.summary-label {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: -0.176px;
}

.summary-value {
  display: flex;
  align-items: center;
  gap: 4px;
}

.coin-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.coin-icon img {
  width: 100%;
  height: 100%;
  display: block;
}

.summary-times {
  font-size: 16px;
  color: #d0ccc1;
  text-align: center;
}

.code-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.section-title {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: -0.176px;
}

.section-sub {
  font-size: 12px;
  color: #989081;
}

.code-input-wrapper {
  display: flex;
  align-items: center;
  height: 48px;
  border-radius: 8px;
  border: 1px solid #151515;
  background: rgba(49, 49, 58, 0.4);
  padding: 0 16px;
  box-sizing: border-box;
}

.code-input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.code-input::placeholder {
  color: #989081;
}

.code-input:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.code-error {
  margin: 4px 0 0;
  font-size: 12px;
  color: #ff4444;
}

.records-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.record-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.record-main {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #b9b1a4;
}

.record-code {
  white-space: nowrap;
}

.record-times {
  white-space: nowrap;
}

.record-time {
  font-size: 12px;
  color: #807666;
}

.record-empty {
  padding: 12px 0;
  font-size: 14px;
  color: #807666;
}
</style>

